<template>
  <div class="pagination-container">
    <el-pagination background layout="total, sizes, prev, pager, next, jumper" v-model:page-size="query.pageSize"
      v-model:current-page="query.pageNum" :page-sizes="resolvedPageSizes" :total="total"
      @size-change="handleSizeChange" @current-change="handleCurrentChange" />
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  query: { type: Object, required: true },
  total: { type: Number, default: 0 },
  pageSizes: { type: Array, default: () => [10, 15, 20] }
})

// 'change' fires on either a size or page change, for existing consumers that just refetch.
// 'size-change' / 'page-change' additionally distinguish which one happened, for consumers
// (e.g. FillTableShell) that need to react differently to a user-driven size pick.
const emit = defineEmits(['change', 'size-change', 'page-change'])

function handleSizeChange(size) {
  // size-change must fire before change: a listener (e.g. FillTableShell) may need to
  // mark this as a user-driven pick before change's own refetch kicks off.
  emit('size-change', size)
  emit('change')
}

function handleCurrentChange(page) {
  emit('page-change', page)
  emit('change')
}

/** Include viewport-measured page size so the sizes dropdown matches actual fetch size. */
const resolvedPageSizes = computed(() => {
  const current = props.query?.pageSize
  const sizes = [...props.pageSizes]
  if (current && !sizes.includes(current)) {
    sizes.push(current)
    sizes.sort((a, b) => a - b)
  }
  return sizes
})
</script>
